module.exports = "<svg #plot></svg>"